var map = {
	"./manage1-active.png": "KK5w",
	"./manage2-active.png": "IUt5",
	"./manage3-active.png": "hxdl",
	"./manage4-active.png": "Y3gA",
	"./manage5-active.png": "41DF",
	"./platform1-active.png": "KXtp",
	"./platform2-active.png": "nsX5",
	"./platform3-active.png": "uEQC",
	"./research1-active.png": "r5zE",
	"./research2-active.png": "9Fvf",
	"./research3-active.png": "PeQr",
	"./research4-active.png": "lUh2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HdWb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business ^\.\/.*\-active\.png$
// module id = HdWb
// module chunks = 0